import {
	TextField as TextFieldMui,
	TextFieldProps as TextFieldPropsMui,
} from '@mui/material';
import * as React from 'react';
import styled from 'styled-components';
import { currencyPosition, formatNumber } from 'utils/utils';
import InputAdornment from './InputAdornment';

type TextFieldProps = TextFieldPropsMui & {
	isCurrency?: boolean;
	handleInputNumberChange: (value: string) => void;
};

const StyledTextField = styled(TextFieldMui)({});

const InputNumber: React.FC<TextFieldProps> = props => {
	const { isCurrency = false, handleInputNumberChange, ...restProps } = props;

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const formattedValue = formatNumber(e.target.value, isCurrency);

		if (formattedValue === null) {
			return;
		}

		handleInputNumberChange(formattedValue);
	};

	return (
		<StyledTextField
			id={props.id}
			value={props.value}
			type="text"
			InputProps={{
				disableUnderline: true,
				endAdornment:
					isCurrency && currencyPosition() === 'firstNumber' ? (
						<InputAdornment position="end">€</InputAdornment>
					) : (
						''
					),
				startAdornment:
					isCurrency && currencyPosition() === 'firstCurrency' ? (
						<InputAdornment style={{ marginTop: 0 }} position="start">
							€
						</InputAdornment>
					) : (
						''
					),
			}}
			variant="filled"
			onChange={handleChange}
			sx={{
				'.input': {
					paddingRight: '8px',
					paddingLeft: '8px',
				},
			}}
			{...restProps}
		>
			{props.children}
		</StyledTextField>
	);
};

export default InputNumber;
